import { init } from "@rematch/core";
import * as models from "./models";
import { reducer as form } from "redux-form";

const store = init({
  models,
  redux: {
    reducers: {
      form
    }
  }
});

export default store;
